import React from "react";
import { MapPin, Navigation, Clock, Phone, Mail, Map } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
export default function FindUsHere() {
  const address = "Foloune House, Gladstonos 120, Unit 5, Limassol 3032, Cyprus";
  const phone = "+357 96 117140";
  const email = "bodywerkscy@gmail.com";
  const hours = "Mon & Wed: 16:00 - 19:30 | Tue & Thu: 09:30 - 12:30 | Fri: 15:00 - 18:30";
  const encodedAddress = encodeURIComponent(address);
  const googleMapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodedAddress}`;
  const appleMapsUrl = `https://maps.apple.com/?q=${encodedAddress}`;
  return <section data-section-id="128218" id="find-your-nearest-clinic" className="relative w-full h-[80vh] min-h-[600px] max-h-[900px] bg-background text-foreground overflow-hidden flex items-center">
      {}
      <div className="absolute inset-0 w-full h-full">
        <iframe title="Studio Location Map" src={`https://maps.google.com/maps?q=${encodedAddress}&t=&z=15&ie=UTF8&iwloc=&output=embed`} className="w-full h-full border-0 grayscale opacity-40 mix-blend-multiply dark:mix-blend-screen dark:opacity-20" allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" />
      </div>

      {}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 pointer-events-none flex flex-col items-center">
        <div className="relative flex items-center justify-center w-12 h-12 bg-background rounded-lg shadow-2xl border border-border">
          <MapPin className="w-6 h-6 text-accent" />
          <div className="absolute -bottom-2 w-1 h-4 bg-accent/50 rounded-lg" />
        </div>
        <div className="w-4 h-1 bg-primary/20 mt-2 blur-[2px]" />
      </div>

      {}
      <div className="container relative z-10 mx-auto px-4 md:px-6 h-full flex items-center">
        <Card className="w-full max-w-md bg-card/90 backdrop-blur-xl border-border/50 shadow-2xl rounded-xl">
          <CardHeader className="border-b border-border/30 pb-6">
            <CardTitle className="text-3xl font-serif tracking-tight text-primary flex items-center gap-3">
              <span className="w-8 h-[1px] bg-accent inline-block" />
              Our Clinic
            </CardTitle>
          </CardHeader>
          
          <CardContent className="pt-6 space-y-6">
            <div className="space-y-4">
              <div className="flex items-start gap-4">
                <MapPin className="w-5 h-5 text-accent shrink-0 mt-0.5" />
                <div>
                  <h4 className="font-sans font-semibold text-primary mb-1">Find Us</h4>
                  <p className="text-secondary text-sm leading-relaxed font-sans">
                    {address}
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <Clock className="w-5 h-5 text-accent shrink-0 mt-0.5" />
                <div>
                  <h4 className="font-sans font-semibold text-primary mb-1">Hours</h4>
                  <p className="text-secondary text-sm leading-relaxed font-sans">
                    {hours}
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <Phone className="w-5 h-5 text-accent shrink-0 mt-0.5" />
                <div>
                  <h4 className="font-sans font-semibold text-primary mb-1">Get in Touch</h4>
                  <p className="text-secondary text-sm leading-relaxed font-sans">
                    {phone}
                  </p>
                  <p className="text-secondary text-sm leading-relaxed font-sans">
                    {email}
                  </p>
                </div>
              </div>
            </div>
          </CardContent>

          <CardFooter className="flex flex-col sm:flex-row gap-3 pt-2 pb-8">
            <Button asChild className="w-full rounded-lg bg-accent hover:bg-accent/90 text-accent-foreground shadow-md transition-all duration-300 hover:scale-105" variant="default">
              <Link to={googleMapsUrl} newTab>
                <Map className="w-4 h-4 mr-2" />
                Google Maps
              </Link>
            </Button>
            <Button asChild className="w-full rounded-lg border-accent text-accent hover:bg-accent/10 transition-all duration-300 hover:scale-105" variant="outline">
              <Link to={appleMapsUrl} newTab>
                <Navigation className="w-4 h-4 mr-2" />
                Apple Maps
              </Link>
            </Button>
          </CardFooter>
        </Card>
      </div>
    </section>;
}